import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { IUserAuthProfile } from '../../core/services/auth.service';

export const AUTH_ACTIONS = createActionGroup({
  source: 'Auth',
  events: {
    'init login check': emptyProps(),
    authenticated: emptyProps(),
    'not authenticated': emptyProps(),
    login: emptyProps(),
    logout: emptyProps(),
    'session terminated': emptyProps(),
    'discovery document loaded': emptyProps(),
    'user profile loaded': props<{ userProfile: IUserAuthProfile }>(),
  },
});
